import Requests from "../../../utils/Requests"
import { handleError  } from "./common.service"

const getDefaultState = () => {
    return {
        loadingWallet: false,
        creatingDvn: false,
        wallet: {
            credit: 0,
            debit: 0,
            balance: 0,
            dvn: null
        },
        showCreateDVN: false,
    }
}

const loadWallet = instance => {

    if(instance.state.loadingWallet){
        return
    }

    instance.setState({
        ...instance.state,
        loadingWallet: true
    })

    Requests(instance.props)
        .withPost()
        .withData({})
        .withUrl('/api/finance/wallet')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadWalletResponse(instance, response), error => handleError(instance, error))
}

const handleLoadWalletResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingWallet: false,
                wallet: response.data.wallet
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingWallet: false
            })
            alert(response.message)
    }
}

const createDvn = instance => {

    if(instance.state.loadingWallet){
        return
    }

    instance.setState({
        ...instance.state,
        creatingDvn: true
    })

    Requests(instance.props)
        .withPost()
        .withData({})
        .withUrl('/api/finance/dvn/create')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleCreateDvnResponse(instance, response), error => handleError(instance, error))
}

const handleCreateDvnResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                creatingDvn: false,
                wallet: {
                    ...instance.state.wallet,
                    dvn: response.data.paystackDedicatedNuban
                }
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                creatingDvn: false
            })
            alert(response.message)
    }
}

const Service = instance => {
    return {
        loadWallet: () => loadWallet(instance),
        createDvn: () => createDvn(instance),
        getDefaultState: () => getDefaultState()
    }
}

export default Service